export default __webpack_public_path__ + "media/images/logo/sns/instagram-b0c6409ac3293c7e486493aca1c2b600.png";